
















import Vue from "vue";
import { mapGetters } from "vuex";
export default Vue.extend({
  name: "TagListFacet",
  computed: {
    ...mapGetters(["getFacetsSelected"]),
  },
  methods: {
    deleteCategorySelected(categorySelected: string) {
      this.$emit("deleteCategory", categorySelected);
    },
  },
});
